module.exports = __webpack_public_path__ + "images/accents/accent-chart-skateboarder@2x-446c95ad0f92e2b51752b5d10aee0ca4.webp";